import { ReduxHelper } from "helpers";
import {
  ICreateZoneRequest,
  IDeleteByIdRequest,
  IGetAllZoneLinesResponse,
  IGetAllZonesResponse,
  IGetByIdRequest,
  IPaginationRequest,
  IUpdateZoneRequest,
  IZone,
} from "model";

export const prefix = "ZONE";

export const getAllZones = ReduxHelper.generateActions<
  IPaginationRequest,
  IGetAllZonesResponse
>(prefix, "GET_ALL_ZONES");
export const getAllZoneLines = ReduxHelper.generateActions<
  IPaginationRequest,
  IGetAllZoneLinesResponse
>(prefix, "GET_ALL_ZONE_LINES");
export const getZoneById = ReduxHelper.generateActions<IGetByIdRequest, IZone>(
  prefix,
  "GET_ZONE_BY_ID"
);
export const createZone = ReduxHelper.generateActions<
  ICreateZoneRequest,
  IZone
>(prefix, "CREATE_ZONE");
export const updateZone = ReduxHelper.generateActions<
  IUpdateZoneRequest,
  IZone
>(prefix, "UPDATE_ZONE");
export const deleteZone = ReduxHelper.generateActions<
  IDeleteByIdRequest,
  { id: string }
>(prefix, "DELETE_ZONE");
export const clearAction = ReduxHelper.generateLocalAction(
  prefix,
  "CLEAR_ACTION"
);
